export const esBilling = {
  'billing.availableAfter': 'Disponible al finalizar',
  'billing.availablePlans': 'Planes disponibles',
  'billing.basicDescription': 'Lo esencial para ordenar y proyectar tu dinero.',
  'billing.cancelAtRenewal': 'Cancelar al renovar',
  'billing.cancelConfirm': 'Confirmar cancelación',
  'billing.cancelDescription': 'Conservarás el acceso hasta la fecha de renovación.',
  'billing.cancelError': 'No pudimos programar la cancelación. Tu plan sigue activo.',
  'billing.cancelPending': 'Programando…',
  'billing.cancelSuccess': 'La cancelación quedó programada para el final del período.',
  'billing.checkoutCanceled': 'Checkout cancelado.',
  'billing.checkoutCanceledDescription': 'No hicimos cambios en tu suscripción.',
  'billing.checkoutError': 'No pudimos abrir Stripe. Vuelve a intentarlo.',
  'billing.checkoutPending': 'Abriendo Stripe…',
  'billing.checkoutReceived': 'Stripe recibió el checkout.',
  'billing.checkoutReceivedDescription':
    'Estamos terminando de confirmar tu suscripción. Tu plan se actualizará en unos segundos.',
  'billing.choose': 'Elegir {name}',
  'billing.currentPlan': 'Plan actual',
  'billing.currentStatus': 'Estado actual',
  'billing.dayRemaining': '{days} día restante con límites Basic.',
  'billing.daysRemaining': '{days} días restantes con límites Basic.',
  'billing.description':
    'Stripe procesa el pago y FinanceGo actualiza tu plan al confirmar la compra.',
  'billing.errorDescription': 'Comprueba tu conexión antes de volver a intentarlo.',
  'billing.errorTitle': 'No pudimos cargar los planes',
  'billing.freeTrial': 'Prueba gratuita',
  'billing.heroEyebrow': 'Planes y suscripción',
  'billing.heroTitle': 'Elige la perspectiva que necesitas.',
  'billing.keepPlan': 'Mantener mi plan',
  'billing.month': 'mes',
  'billing.mostPopular': 'Más elegido',
  'billing.nextRenewal': 'Próxima renovación: {date}.',
  'billing.noScheduledDate': 'Sin fecha programada',
  'billing.planName': 'Plan {name}',
  'billing.plusDescription': 'Más capacidad para crecer y compartir.',
  'billing.premiumDescription': 'Análisis profundo con Adviser incluido.',
  'billing.secureCheckout': 'Pago procesado por Stripe',
  'billing.trialDays': '{days} días de prueba',
  'billing.trialDay': '{days} día de prueba',
  'billing.trialDescription': 'Durante la prueba tienes los límites de Basic.',
  'billing.trialEnded': 'La prueba de 7 días ya terminó.',
  'billing.trialExpired': 'Tu prueba terminó',
  'billing.trialExpiredDescription': 'Elige un plan para volver a usar tus finanzas.',
  'billing.viewPlans': 'Ver planes',
  'billing.year': 'año',
} as const;

export const enBilling: Record<keyof typeof esBilling, string> = {
  'billing.availableAfter': 'Available when current plan ends',
  'billing.availablePlans': 'Available plans',
  'billing.basicDescription': 'The essentials to organize and project your money.',
  'billing.cancelAtRenewal': 'Cancel at renewal',
  'billing.cancelConfirm': 'Confirm cancellation',
  'billing.cancelDescription': 'You will keep access until the renewal date.',
  'billing.cancelError': 'We could not schedule cancellation. Your plan remains active.',
  'billing.cancelPending': 'Scheduling…',
  'billing.cancelSuccess': 'Cancellation is scheduled for the end of the billing period.',
  'billing.checkoutCanceled': 'Checkout canceled.',
  'billing.checkoutCanceledDescription': 'We made no changes to your subscription.',
  'billing.checkoutError': 'We could not open Stripe. Try again.',
  'billing.checkoutPending': 'Opening Stripe…',
  'billing.checkoutReceived': 'Stripe received the checkout.',
  'billing.checkoutReceivedDescription':
    'We are finishing your subscription confirmation. Your plan will update shortly.',
  'billing.choose': 'Choose {name}',
  'billing.currentPlan': 'Current plan',
  'billing.currentStatus': 'Current status',
  'billing.dayRemaining': '{days} day remaining with Basic limits.',
  'billing.daysRemaining': '{days} days remaining with Basic limits.',
  'billing.description':
    'Stripe processes payment, and FinanceGo updates your plan after purchase confirmation.',
  'billing.errorDescription': 'Check your connection before trying again.',
  'billing.errorTitle': 'We could not load the plans',
  'billing.freeTrial': 'Free trial',
  'billing.heroEyebrow': 'Plans and subscription',
  'billing.heroTitle': 'Choose the perspective you need.',
  'billing.keepPlan': 'Keep my plan',
  'billing.month': 'month',
  'billing.mostPopular': 'Most popular',
  'billing.nextRenewal': 'Next renewal: {date}.',
  'billing.noScheduledDate': 'No date scheduled',
  'billing.planName': '{name} plan',
  'billing.plusDescription': 'More capacity to grow and share.',
  'billing.premiumDescription': 'Deeper analysis with Adviser included.',
  'billing.secureCheckout': 'Payment processed by Stripe',
  'billing.trialDays': '{days} trial days',
  'billing.trialDay': '{days} trial day',
  'billing.trialDescription': 'During the trial you have Basic limits.',
  'billing.trialEnded': 'The 7-day trial has ended.',
  'billing.trialExpired': 'Your trial has ended',
  'billing.trialExpiredDescription': 'Choose a plan to use your finances again.',
  'billing.viewPlans': 'View plans',
  'billing.year': 'year',
};
